// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"57ad0ecb","450":"25e189a5","453":"b5abc8a2","867":"562f5f58"}[chunkId] + ".chunk.js";
};